import React, { Fragment } from 'react';
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner';

const TeamsRankTableModal = ({
	isVisible,
	rankModalRef,
	handleTeamClick,
	gradeRanks,
	currentTeamId,
	currentTeamRef,
	loading
}) => {
	if (!isVisible) return null;

	return (
		<div
			className="absolute bg-white dark:bg-dark-card border border-gray-300 dark:border-dark-border shadow-lg rounded-lg text-sm w-80 z-10 overflow-y-auto text-gray-800 dark:text-dark-text"
			style={{
				top: 'calc(100% + 10px)',
				left: '50%',
				transform: 'translateX(-50%)',
				maxHeight: '350px'
			}}
			ref={rankModalRef}
		>
			<div className="max-h-screen">
				{loading ? (
					<div className="p-4 text-center">
						<LoadingSpinner />
					</div>
				) : gradeRanks && gradeRanks.length > 0 ? (
					<table className="min-w-full relative">
						<thead className="sticky top-0 bg-gray-100 dark:bg-gray-800">
							<tr>
								<th className="pl-4 pr-3 py-4 text-left text-xs text-gray-800 dark:text-dark-text font-bold tracking-wider">
									Rank
								</th>
								<th className="px-3 py-4 text-left text-xs text-gray-800 dark:text-dark-text font-bold tracking-wider">
									Name
								</th>
								<th className="pl-3 pr-4 py-4 text-left text-xs text-gray-800 dark:text-dark-text font-bold tracking-wider">
									Score
								</th>
							</tr>
						</thead>
						<tbody>
							{gradeRanks.map((team) => (
								<tr
									key={team.id}
									className={`hover:bg-gray-100 dark:hover:bg-gray-700 ${team.id === currentTeamId
										? 'font-bold'
										: ''}`}
									onClick={() => handleTeamClick(team.id)}
								>
									<td className="pl-4 pr-3 py-2 whitespace-nowrap">
										{team.rank}
									</td>
									<td
										className={`text-blue-500 dark:text-blue-400 px-3 py-2 whitespace-nowrap hover:underline cursor-pointer ${team.id ===
										currentTeamId
											? 'font-bold hover:no-underline hover:cursor-none'
											: ''}`}
										style={team.id === currentTeamId ? { color: '#6b7280' } : {}}
										ref={team.id === currentTeamId ? currentTeamRef : null}
									>
										{team && team.name ? team.name : 'Unknown Team'}
									</td>
									<td
										className={`pl-3 pr-4 py-2 whitespace-nowrap ${team.id ===
										currentTeamId
											? 'font-bold'
											: ''}`}
									>
										{team.score}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				) : (
					<div className="p-4 text-center">No results found.</div>
				)}
			</div>
		</div>
	);
};

export default TeamsRankTableModal;
